import { render } from "./stickySummary.vue?vue&type=template&id=9b6ec7c8&scoped=true"
import script from "./stickySummary.vue?vue&type=script&lang=js"
export * from "./stickySummary.vue?vue&type=script&lang=js"

import "./stickySummary.vue?vue&type=style&index=0&id=9b6ec7c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b6ec7c8"]])

export default __exports__